import { render, staticRenderFns } from "./SelectGood.vue?vue&type=template&id=5c601860&scoped=true"
import script from "./SelectGood.vue?vue&type=script&lang=js"
export * from "./SelectGood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c601860",
  null
  
)

export default component.exports